'use client';

import { c as _c } from "react/compiler-runtime";
import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import type { DbAttachment } from '../Attachments/types';
import { FullscreenMarkdownEditor } from '../FullscreenMarkdownEditor';
export type MarkdownAndAttachmentsValue = {
  markdown: {
    id?: string;
    content: string;
  };
  attachments?: DbAttachment[];
};
type MarkdownAndAttachmentsFieldProps<TFieldValues extends FieldValues> = {
  name: FieldPath<TFieldValues>;
  height?: number;
  markdownOnly?: boolean;
  disabled?: boolean;
  defaultMarkdownContent?: string;
  preserveMarkdownId?: boolean;
  onContentChange?: (markdown: string) => void;
};
export function MarkdownAndAttachmentsField(t0) {
  const $ = _c(11);
  const {
    name,
    height,
    markdownOnly,
    disabled,
    defaultMarkdownContent: t1,
    preserveMarkdownId: t2,
    onContentChange
  } = t0;
  const defaultMarkdownContent = t1 === undefined ? "" : t1;
  const preserveMarkdownId = t2 === undefined ? true : t2;
  const {
    control
  } = useFormContext();
  let t3;
  if ($[0] !== defaultMarkdownContent || $[1] !== disabled || $[2] !== height || $[3] !== markdownOnly || $[4] !== onContentChange || $[5] !== preserveMarkdownId) {
    t3 = t4 => {
      const {
        field
      } = t4;
      const currentValue = field.value as MarkdownAndAttachmentsValue | undefined;
      const editorValue = {
        markdown: currentValue?.markdown?.content ?? defaultMarkdownContent,
        attachments: currentValue?.attachments ?? []
      };
      return <FullscreenMarkdownEditor height={height} markdownOnly={markdownOnly} disabled={disabled} value={editorValue} onChange={next => {
        const nextMarkdown = {
          content: next.markdown
        };
        if (preserveMarkdownId && currentValue?.markdown?.id) {
          nextMarkdown.id = currentValue.markdown.id;
        }
        field.onChange({
          markdown: nextMarkdown,
          attachments: next.attachments ?? []
        } satisfies MarkdownAndAttachmentsValue);
        onContentChange?.(next.markdown);
      }} />;
    };
    $[0] = defaultMarkdownContent;
    $[1] = disabled;
    $[2] = height;
    $[3] = markdownOnly;
    $[4] = onContentChange;
    $[5] = preserveMarkdownId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== control || $[8] !== name || $[9] !== t3) {
    t4 = <Controller name={name} control={control} render={t3} />;
    $[7] = control;
    $[8] = name;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}